/* @flow */
import React from 'react';
import {connect} from 'react-redux';
import {
    cleanBarReportCashboxes, fetchBarReportCashboxes, setBarReportCashboxValue
} from '../../../../common/menu/report/cashboxes/actions';
import NumericalButton from '../../../components/keyboard/NumericalButton';
import MoneyCounterButton from '../../../components/keyboard/MoneyCounterButton';

class CashboxesPanel extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        barReportCashboxes: React.PropTypes.object,
        barId: React.PropTypes.number,
        cleanBarReportCashboxes: React.PropTypes.func,
        fetchBarReportCashboxes: React.PropTypes.func,
        setBarReportCashboxValue: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this.getWarningMessage = this.getWarningMessage.bind(this);
    }

    componentWillMount() {
        const {fetchBarReportCashboxes, barId} = this.props;
        fetchBarReportCashboxes(barId);
    }

    componentWillUnmount() {
        const {cleanBarReportCashboxes} = this.props;
        cleanBarReportCashboxes();
    }

    getWarningMessage(cashbox) {
        const lastAmount = cashbox.get('lastAmount') === null ? 0 : cashbox.get('lastAmount');
        if (lastAmount === -1 || cashbox.get('beginningAmount') === lastAmount) {
            return false;
        }
        const amount = cashbox.get('beginningAmount') - lastAmount;
        if (amount < 0) {
            return 'Chybí ' + (amount * -1);
        } else {
            return 'Přebývá ' + amount;
        }
    }

    render() {
        const {barReportCashboxes, setBarReportCashboxValue, msg} = this.props;

        return (
            <div className="menuPage">

                <div className="menuPage-header">
                  <div className="menuPage-header-title" style={{width: '100%'}}>
                    <div className="menuPage-title">
                        {msg.moneyCount.dailyReport}
                    </div>
                  </div>
                </div>

              <div className="menuPage-content">
                <div className="table">

                    <div className="table-head">
                        <div className="table-head-row">
                            <div className="table-head-cell" style={{width: '40%'}}>
                                <span>{msg.moneyCount.cashbox}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '30%'}}>
                                <span>{msg.moneyCount.start}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '30%'}}>
                                <span>{msg.moneyCount.end}</span>
                            </div>
                        </div>
                    </div>
                    <div className="table-body">
                        {!!barReportCashboxes && barReportCashboxes.map((cashbox, i) => {
                            const warning = this.getWarningMessage(cashbox);
                            return (
                                <div className="table-row"
                                     key={`cashbox-count-${i}`}>

                                    <div className="table-cell" style={{width: '40%'}}>
                                        <div className={`boxBtn text-left text-black`}>
                                            <div className="boxBtn-inner">
                                                <span> {cashbox.getIn(['cashbox', 'name'])}
                                                    {!!warning &&
                                                    <span className="boxBtn-info">
                                                        {warning}
                                                    </span>
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="table-cell" style={{width: '20%'}}>
                                        <NumericalButton
                                            label={`${cashbox.getIn(['cashbox', 'name'])} - počátek`}
                                            nonDecimal
                                            className={`boxBtn text-right text-black color-white`}
                                            removedClassName="boxBtn"
                                            onSubmit={(val) => setBarReportCashboxValue(cashbox.get('id'), 'START', val)}
                                            stringAfter={cashbox.getIn(['cashbox', 'currency', 'symbol'])}
                                            value={cashbox.getIn(['beginningAmount'])}
                                        />
                                    </div>

                                    <div className="table-cell" style={{width: '10%'}}>
                                        {cashbox.getIn(['cashbox', 'type']) === 'CASH' &&
                                            <MoneyCounterButton className={`boxBtn color-green`}
                                                                removedClassName="boxBtn"
                                                                coins={cashbox.get('beginningCoins')}
                                                                onSubmit={(val, coins) => setBarReportCashboxValue(cashbox.get('id'), 'START', val, coins)}/>
                                        }
                                    </div>

                                    <div className="table-cell" style={{width: '20%'}}>
                                        <NumericalButton
                                            nonDecimal
                                            label={`${cashbox.getIn(['cashbox', 'name'])} - konec`}
                                            className={`boxBtn text-black text-right color-white`}
                                            removedClassName="boxBtn"
                                            onSubmit={(val) => setBarReportCashboxValue(cashbox.get('id'), 'END', val)}
                                            stringAfter={cashbox.getIn(['cashbox', 'currency', 'symbol'])}
                                            value={cashbox.getIn(['endAmount'])}
                                        />
                                    </div>

                                    <div className="table-cell" style={{width: '10%'}}>
                                        {cashbox.getIn(['cashbox', 'type']) === 'CASH' &&
                                        <MoneyCounterButton className={`boxBtn color-green`}
                                                            removedClassName="boxBtn"
                                                            coins={cashbox.get('endCoins')}
                                                            onSubmit={(val, coins) => setBarReportCashboxValue(cashbox.get('id'), 'END', val, coins)} />
                                        }
                                    </div>

                                </div>
                            )
                        })}
                    </div>
                </div>
              </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    barReportCashboxes: state.barReportCashboxes.get('barReportCashboxes'),
    barId: state.bars.getIn(['bar', 'id'])
}), {
    fetchBarReportCashboxes, cleanBarReportCashboxes, setBarReportCashboxValue
})(CashboxesPanel);



// WEBPACK FOOTER //
// ./src/browser/menu/report/cashboxes/CashboxesPanel.js